import React from 'react'
import { DragDropContext } from 'react-beautiful-dnd'

const DropContext = ({ children, onDragEnd }) => {
	return <DragDropContext onDragEnd={onDragEnd}>{children}</DragDropContext>
}

export default DropContext
